import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from '../shared/shared.module';
import { PaymentsService } from './services/payments.service';
import { LoginService } from './services/login.service';
import { RestService } from './services/rest.service';
import { ScriptService } from './services/script.service';
import { BalanceService } from './services/balance.service';
import { UserService } from './services/user.services';
import { InboxService } from '../pages/inbox/services/inbox.service';
import { StorageService } from './services/storage.service';
import { PushNotificationsService } from './services/push-notifications.service';
import { PaymentsFilterService } from './services/payments-filter.service';
import { LoaderModule } from './components/loader/loader.module';
import { ToolbarModule } from '../pages/public/toolbar/toolbar.module';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MessageWarnModule } from '../pages/public/message-warn/message-warn.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
  imports: [CommonModule, SharedModule, LoaderModule, TranslateModule.forChild({ isolate: false }), MatDialogModule],
  providers: [
    PaymentsService,
    LoginService,
    RestService,
    ScriptService,
    BalanceService,
    UserService,
    InboxService,
    PushNotificationsService,
    StorageService,
    PaymentsFilterService,
    ToolbarModule,
    MessageWarnModule,
    MatSlideToggleModule,
    {
      provide: MatDialogRef,
      useValue: {}
    }
  ]
})
export class CoreModule {}
